import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Switch, Route, withRouter } from 'react-router-dom'
import moment from 'moment'
import EventEmitter from 'events'
import loadable from '@loadable/component'

import StringFormat from './utils/StringFormat'
import HeaderFooterBase from './pages/HeaderFooterBase'
import { FF4JProvider } from 'components/ff4j'

const Proposal = loadable(() => import('./pages/Proposal'))
const RegisterSteps = loadable(() => import('./pages/RegisterSteps'))

export const storageHandler = new EventEmitter()

export class App extends Component {
    componentDidUpdate(prevProps) {
        const { cartProducts } = this.props

        if (
            JSON.stringify(cartProducts) !==
            JSON.stringify(prevProps.cartProducts)
        ) {
            if (cartProducts.length === 0) {
                localStorage.removeItem('cart.products')
                storageHandler.emit('update-products')
                return
            }
            localStorage.setItem(
                'cart.products',
                JSON.stringify({
                    products: cartProducts,
                    dateTime: moment().format()
                })
            )
            storageHandler.emit('update-products')
        }
    }

    render() {
        const config = {
            apiUrl: '/flags',
            fetchTimeout: 3_000,
            revalidateInterval: 60_000,
            useLocalStorage: true,
            localStorageKey: 'flags'
        }
        return (
            <FF4JProvider config={config}>
                <Switch>
                    <Route path="/proposta" component={Proposal} />
                    <Route path="/cadastro" component={RegisterSteps} />
                    <Route path="/" component={HeaderFooterBase} />
                </Switch>
            </FF4JProvider>
        )
    }
}
const mapStateToProps = (state) => ({
    products: state.cart.products.map((product) => ({
        name: StringFormat.simpleNameProducts(product.id),
        id: product.id,
        price: product.value,
        quantity: product.qnt
    })),
    cartProducts: state.cart.products
})

export default withRouter(connect(mapStateToProps, null)(App))
